import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Image from "../components/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  min-height: 430px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.4s;
  border-radius: 12px;
  @media (hover: hover) {
    &:hover {
      transform: translateY(-5px);
    }
  }
`;
const EmployeeImage = styled(Image)`
  width: 100%;
  height: 415px;
  object-fit: cover;
  border-radius: 12px;
`;
const Name = styled.p`
  font-size: 1.1rem;
  margin-bottom: 5px !important;
`;
const Text = styled.p`
  font-size: 0.8rem;
  white-space: nowrap;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: 0.9rem;
  }
`;
const TextOverlay = styled.div`
  position: absolute;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f5f5f5;
  color: ${({ theme, $textColor }) =>
    $textColor ? $textColor : theme.colors.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 10px 20px;
  p {
    width: auto;
    margin: 2px 0;
  }
  letter-spacing: ${({ $letterSpacing }) => $letterSpacing + "px"};
  line-height: ${({ $rowSpacing }) => $rowSpacing};
  a {
    color: ${({ theme, $linkColor }) =>
      $linkColor ? $linkColor : theme.colors.black};
  }
`;
const StyledExternalLink = styled.a`
  font-size: 0.8rem;
  color: ${({ theme, $textColor }) =>
    $textColor ? $textColor : theme.colors.white};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: 0.9rem;
  }
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 5px;
`;
export default function EmployeeCard({
  image,
  imgUrl,
  imgAlt,
  title,
  name,
  city,
  email,
  phone,
  backgroundColorHex,
  textColorHex,
  letterSpacing,
  rowSpacing,
  linkColor,
  className,
}) {
  return (
    <Wrapper className={className}>
      <EmployeeImage image={image} alt={imgAlt} src={imgUrl} />
      <TextOverlay
        $backgroundColor={backgroundColorHex ? backgroundColorHex : null}
        $textColor={textColorHex ? textColorHex : null}
        $letterSpacing={letterSpacing ? letterSpacing : null}
        $rowSpacing={rowSpacing ? rowSpacing : null}
        $linkColor={linkColor ? linkColor : null}
      >
        <Row>
          <Name>{name}</Name>
          <Text>
            - {title} {city && <span>- {city}</span>}
          </Text>
        </Row>
        <StyledExternalLink
          href={"mailto:" + email}
          $textColor={textColorHex ? textColorHex : null}
        >
          <FontAwesomeIcon icon={faEnvelope} /> {email}
        </StyledExternalLink>
        <StyledExternalLink
          href={"tel:" + phone}
          $textColor={textColorHex ? textColorHex : null}
        >
          <FontAwesomeIcon icon={faPhone} /> {phone}
        </StyledExternalLink>
      </TextOverlay>
    </Wrapper>
  );
}
EmployeeCard.propTypes = {
  image: PropTypes.object,
  imgUrl: PropTypes.object,
  imgAlt: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  city: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  backgroundColorHex: PropTypes.string,
  textColorHex: PropTypes.string,
  letterSpacing: PropTypes.string,
  rowSpacing: PropTypes.string,
  linkColor: PropTypes.string,
  linkColorHex: PropTypes.string,
  className: PropTypes.string,
};

EmployeeCard.defaultProps = {
  image: undefined,
  imgUrl: undefined,
  imgAlt: undefined,
  title: undefined,
  name: undefined,
  city: undefined,
  email: undefined,
  phone: undefined,
  backgroundColorHex: undefined,
  textColorHex: undefined,
  className: undefined,
};
